export var ArticlePlayErrors;
(function (ArticlePlayErrors) {
    ArticlePlayErrors["noPlayableAsset"] = "noPlayableAsset";
    ArticlePlayErrors["notAuthenticated"] = "notAuthenticated";
    ArticlePlayErrors["needEntitlement"] = "needEntitlement";
    ArticlePlayErrors["serverError"] = "serverError";
    ArticlePlayErrors["offlineError"] = "offlineError";
    ArticlePlayErrors["maxConcurrentStreamNumberError"] = "maxConcurrentStreamNumberError";
})(ArticlePlayErrors || (ArticlePlayErrors = {}));
